import { render, staticRenderFns } from "./BarraEstado.vue?vue&type=template&id=8bea694c&"
import script from "./BarraEstado.vue?vue&type=script&lang=js&"
export * from "./BarraEstado.vue?vue&type=script&lang=js&"
import style0 from "./BarraEstado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports